import { createAutoGeneratedUserReq } from "Requests/User.req";
import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import userStore from "stores/userStore";

const InitialNickname = () => {
  const navigate = useNavigate();
  const user = userStore((state) => state);
  const [nicknameInput, setNicknameInput] = useState("");

  const goBack = () => {
    navigate(-1);
  };

  const goToHomePageWithoutLogin = async () => {
    try {
      let trimmed = nicknameInput.trim();
      if (trimmed.length === 0) {
        trimmed = null;
      }
      console.log(trimmed);
      const result = await createAutoGeneratedUserReq(trimmed);
      const { user: userInfo, token } = result;
      const { nickname, autoGenerated } = userInfo;
      console.log(userInfo);

      user.setUid(userInfo.uid);
      user.setNickname(nickname);
      user.setAutoGenerated(autoGenerated);
      user.setToken(token);
      navigate("/");
    } catch (err) {
      console.error(err);
      toast.error("오류가 발생했습니다.");
    }
  };

  return (
    <div className="initial-nickname page">
      {/* <div className="mips">MIPS</div> */}
      <div className="label">닉네임 설정</div>
      <div className="input-container">
        <input
          className="main-input"
          type="text"
          placeholder="닉네임 (옵션)"
          vluae={nicknameInput}
          onChange={(e) => {
            setNicknameInput(e.target.value);
          }}
        />
        <div className="announcement">회원님의 계정은 생성 24시간 후 삭제됩니다.</div>
      </div>
      <div className="main-btn-container">
        <button className="main-btn highlight" onClick={goToHomePageWithoutLogin}>
          시작하기
        </button>
        <button className="main-btn unhighlight" onClick={goBack}>
          돌아가기
        </button>
      </div>
    </div>
  );
};

export default InitialNickname;
